import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import order from '@/store/order/index'
import orderStatus from '@/store/order/orderStatus'
import orderBasket from '@/store/order/orderBasket'
import orderCommonLabel from '@/store/order/orderCommonLabel'
import hbProductMatching from '@/store/hepsiburada/hbProductMatching'
import tyStoreProduct from '@/store/trendyol/tyStoreProduct'
import tyCreateProduct from '@/store/trendyol/tyCreateProduct'
import tySearchProduct from '@/store/trendyol/tySearchProduct'
import tyProductMatch from '@/store/trendyol/tyProductMatch'
import azProductMatching from '@/store/amazon/azProductMatching'
import azStoreProduct from '@/store/amazon/azStoreProduct'
import azFbaBasket from '@/store/amazon/azFbaBasket'
import stock from '@/store/stock/index'
import stockV2 from '@/store/stock/v2/index'
import stockEntry from '@/store/stock/stockEntry'
import stocktaking from '@/store/stock/stocktaking'
import stockComfirm from '@/store/stock/stockComfirm'
import company from '@/store/company'
import current from '@/store/company/current'
import cargoCompany from '@/store/cargo-company/index'
import agreement from '@/store/agreement/index'
import agreementDetail from '@/store/agreement/agreementDetail'
import users from '@/store/user/index'
import home from '@/store/home/index'
import productBrand from '@/store/product/brand'
import question from '@/store/question'
import readyAnswer from '@/store/question/ReadyAnswer'
import orderQuestion from '@/store/question/orderQuestion'
import invoice from '@/store/invoice'
import preOrder from '@/store/pre-order/preOrder'
import preOrderStatus from '@/store/pre-order/preOrderStatus'
import kigagu from '@/store/kigagu'
import orderCargo from '@/store/order/OrderCargo'
import stockRack from '@/store/v2/stock/rack'
import activeStock from '@/store/v2/stock/activeStock'
import stocktakingV2 from '@/store/v2/stock/stocktaking'
import stocktakingConfirm from '@/store/v2/stock/stocktakingConfirm'
import tyBrands from './trendyol/tyBrand'
import tyProductV2 from './v2/trendyol/index'
import tyManagement from './v2/trendyol/management'
import store from './store/index'
import tyProduct from './trendyol/index'
import hbCampaign from './hepsiburada/campaign'
import supplierAuthors from './supplier/authors'
import suplierPublisher from './supplier/publisher'
import supplierCategory from './supplier/category'
import supplierProduct from './supplier/product'
import supplierProductImport from './supplier/supplierProductImport'
import supplier from './supplier/index'
import productPublisher from './product/publisher'
import productCategory from './product/category'
import productV2 from './v2/products/product'
import product from './product/index'
import matchStatus from './status/matchStatus'
import verticalMenu from './vertical-menu'
import appConfig from './app-config'
import app from './app'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        app,
        appConfig,
        verticalMenu,
        matchStatus,
        product,
        productV2,
        productCategory,
        productPublisher,
        productBrand,
        order,
        orderStatus,
        orderCargo,
        orderBasket,
        orderCommonLabel,
        supplier,
        supplierProduct,
        supplierProductImport,
        supplierCategory,
        suplierPublisher,
        supplierAuthors,
        hbCampaign,
        hbProductMatching,
        tyProduct,
        tyBrands,
        tyProductV2,
        tyManagement,
        tyStoreProduct,
        tyCreateProduct,
        tySearchProduct,
        tyProductMatch,
        azProductMatching,
        azStoreProduct,
        azFbaBasket,
        preOrder,
        preOrderStatus,
        store,
        stock,
        stockV2,
        stockEntry,
        stocktaking,
        stockComfirm,
        company,
        current,
        cargoCompany,
        agreement,
        agreementDetail,
        users,
        home,
        question,
        readyAnswer,
        orderQuestion,
        invoice,
        kigagu,
        stockRack,
        activeStock,
        stocktakingV2,
        stocktakingConfirm,
    },
    strict: process.env.DEV,
})
